import App from "../app";

export default class Header {
    constructor(headerId) {
        this.header = document.getElementById(headerId);
        if (!this.header) return;

        this.langBtn = this.header.querySelector(".no-header__btn.--language");
        this.langModal = document.getElementById("langModal");
        this.langCloseBtn = this.langModal
            ? this.langModal.querySelector(".no-lang-modal__close")
            : null;
        this.langBackdrop = this.langModal
            ? this.langModal.querySelector(".no-lang-modal__backdrop")
            : null;
        this.langItems = this.langModal
            ? this.langModal.querySelectorAll(".no-lang-modal__item")
            : null;

        this.searchBtn = this.header.querySelector(".no-header__btn.--search");
        // searchModal은 header 외부에 있으므로 document에서 찾기
        this.searchModal = document.getElementById("searchModal");
        this.searchCloseBtn = this.searchModal
            ? this.searchModal.querySelector(".no-search-modal__close")
            : null;
        this.searchBackdrop = this.searchModal
            ? this.searchModal.querySelector(".no-search-modal__backdrop")
            : null;
        this.searchInput = this.searchModal
            ? this.searchModal.querySelector(".no-search-modal__input")
            : null;
        this.searchForm = this.searchModal
            ? this.searchModal.querySelector(".no-search-modal__form")
            : null;

        // 디버깅: 모달이 제대로 로드되었는지 확인
        if (this.searchBtn && !this.searchModal) {
            console.warn(
                "[Header] Search button found but search modal not found in DOM"
            );
        }

        this.setDrawer(null);
        this.init();
    }

    setDrawer(drawer) {
        this.drawer = drawer;
    }

    init() {
        // 초기 스크롤 상태 체크 및 헤더 클래스 설정
        this.handleScroll();
        this.activeScroll();
        this.bindLanguageModal();
        this.bindSearchModal();
    }

    activeScroll() {
        window.addEventListener("scroll", this.handleScroll.bind(this));
    }

    isScrolling() {
        return window.scrollY > this.getOffsetHeight();
    }

    getOffsetHeight() {
        return this.header.querySelector(".no-header__inner").offsetHeight;
    }

    handleScroll() {
        if (window.scrollY > this.getOffsetHeight()) {
            this.header.classList.add("--scrolling");
        } else {
            this.header.classList.remove("--scrolling");
        }
    }

    getToggleButton() {
        return this.header.querySelector(".no-header__btn.--toggle");
    }

    bindLanguageModal() {
        if (!this.langBtn || !this.langModal) return;

        this.langBtn.addEventListener("click", () => this.openLangModal());

        if (this.langCloseBtn) {
            this.langCloseBtn.addEventListener("click", () =>
                this.closeLangModal()
            );
        }

        if (this.langBackdrop) {
            this.langBackdrop.addEventListener("click", () =>
                this.closeLangModal()
            );
        }

        document.addEventListener("keydown", (e) => {
            if (
                e.key === "Escape" &&
                this.langModal.classList.contains("is-open")
            ) {
                this.closeLangModal();
            }
        });

        if (this.langItems && this.langItems.length) {
            // const labelEl = this.langBtn.querySelector("span");

            this.langItems.forEach((btn) => {
                btn.addEventListener("click", () => {
                    this.langItems.forEach((b) =>
                        b.classList.remove("is-active")
                    );
                    btn.classList.add("is-active");

                    // if (labelEl) {
                    //     labelEl.textContent = btn.textContent.trim();
                    // }

                    this.closeLangModal();
                });
            });
        }
    }

    openLangModal() {
        if (!this.langModal) return;

        this.langModal.classList.add("is-open");
        this.langModal.setAttribute("aria-hidden", "false");
        App.getInstance().setLock(true);

        const backdrop = this.langModal.querySelector(
            ".no-lang-modal__backdrop"
        );
        const panel = this.langModal.querySelector(".no-lang-modal__panel");
        const items = this.langModal.querySelectorAll(
            ".no-lang-modal__list li"
        );

        // GSAP 애니메이션
        const tl = gsap.timeline();

        tl.to(this.langModal, {
            opacity: 1,
            duration: 0.3,
            ease: "power2.out",
        })
            .to(
                backdrop,
                {
                    opacity: 1,
                    duration: 0.4,
                    ease: "power2.out",
                },
                "-=0.2"
            )
            .to(
                panel,
                {
                    scale: 1,
                    y: 0,
                    opacity: 1,
                    duration: 0.5,
                    ease: "back.out(1.4)",
                },
                "-=0.3"
            )
            .to(
                items,
                {
                    opacity: 1,
                    x: 0,
                    duration: 0.4,
                    stagger: {
                        amount: 0.3,
                        from: "start",
                    },
                    ease: "power3.out",
                },
                "-=0.3"
            );
    }

    closeLangModal() {
        if (!this.langModal) return;

        const backdrop = this.langModal.querySelector(
            ".no-lang-modal__backdrop"
        );
        const panel = this.langModal.querySelector(".no-lang-modal__panel");
        const items = this.langModal.querySelectorAll(
            ".no-lang-modal__list li"
        );

        const app = App.getInstance();

        // 닫기 애니메이션
        const tl = gsap.timeline({
            onComplete: () => {
                this.langModal.classList.remove("is-open");
                this.langModal.setAttribute("aria-hidden", "true");

                if (!app.drawer.isDrawerOpen) {
                    app.setLock(false);
                }

                // 초기 상태로 리셋
                gsap.set(this.langModal, { opacity: 0 });
                gsap.set(panel, { scale: 0.9, y: 30, opacity: 0 });
                gsap.set(items, { opacity: 0, x: -10 });
                gsap.set(backdrop, { opacity: 0 });
            },
        });

        tl.to(items, {
            opacity: 0,
            x: 10,
            duration: 0.2,
            stagger: {
                amount: 0.15,
                from: "end",
            },
            ease: "power2.in",
        })
            .to(
                panel,
                {
                    scale: 0.95,
                    y: 20,
                    opacity: 0,
                    duration: 0.3,
                    ease: "power2.in",
                },
                "-=0.1"
            )
            .to(
                backdrop,
                {
                    opacity: 0,
                    duration: 0.3,
                    ease: "power2.in",
                },
                "-=0.2"
            )
            .to(
                this.langModal,
                {
                    opacity: 0,
                    duration: 0.2,
                    ease: "power2.in",
                },
                "-=0.15"
            );
    }

    bindSearchModal() {
        if (!this.searchBtn) {
            console.warn("[Header] Search button not found");
            return;
        }

        if (!this.searchModal) {
            console.warn("[Header] Search modal not found");
            return;
        }

        // 초기 상태 설정
        const backdrop = this.searchModal.querySelector(
            ".no-search-modal__backdrop"
        );
        const panel = this.searchModal.querySelector(".no-search-modal__panel");

        if (backdrop && panel) {
            gsap.set(this.searchModal, { opacity: 0, visibility: "hidden" });
            gsap.set(backdrop, { opacity: 0 });
            gsap.set(panel, { y: -20, opacity: 0 });
        }

        this.searchBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.openSearchModal();
        });

        if (this.searchCloseBtn) {
            this.searchCloseBtn.addEventListener("click", () =>
                this.closeSearchModal()
            );
        }

        if (this.searchBackdrop) {
            this.searchBackdrop.addEventListener("click", () =>
                this.closeSearchModal()
            );
        }

        document.addEventListener("keydown", (e) => {
            if (
                e.key === "Escape" &&
                this.searchModal.classList.contains("is-open")
            ) {
                this.closeSearchModal();
            }
        });

        // Form submit 핸들러
        if (this.searchForm) {
            this.searchForm.addEventListener("submit", (e) => {
                const input = this.searchForm.querySelector(
                    ".no-search-modal__input"
                );
                if (input && input.value.trim() === "") {
                    e.preventDefault();
                    return false;
                }
                // form이 정상적으로 submit되도록 함
                // action 경로가 올바르면 자동으로 이동함
            });
        }

        // Input에서 엔터 키 처리
        if (this.searchInput) {
            this.searchInput.addEventListener("keydown", (e) => {
                if (e.key === "Enter") {
                    // form submit이 자동으로 처리되도록 함
                    // preventDefault를 호출하지 않음
                }
            });
        }
    }

    openSearchModal() {
        if (!this.searchModal) {
            console.error("[Header] Search modal element not found");
            return;
        }

        console.log("[Header] Opening search modal", this.searchModal);

        this.searchModal.classList.add("is-open");
        this.searchModal.setAttribute("aria-hidden", "false");
        App.getInstance().setLock(true);

        const backdrop = this.searchModal.querySelector(
            ".no-search-modal__backdrop"
        );
        const panel = this.searchModal.querySelector(".no-search-modal__panel");
        const input = this.searchModal.querySelector(".no-search-modal__input");

        if (!backdrop || !panel) {
            console.error("[Header] Search modal elements not found", {
                backdrop,
                panel,
            });
            return;
        }

        // GSAP 애니메이션
        const tl = gsap.timeline();

        tl.set(this.searchModal, { visibility: "visible" })
            .to(this.searchModal, {
                opacity: 1,
                duration: 0.3,
                ease: "power2.out",
            })
            .to(
                backdrop,
                {
                    opacity: 1,
                    duration: 0.4,
                    ease: "power2.out",
                },
                "-=0.2"
            )
            .to(
                panel,
                {
                    y: 0,
                    opacity: 1,
                    duration: 0.5,
                    ease: "back.out(1.2)",
                },
                "-=0.3"
            );

        // 입력 필드에 포커스
        if (input) {
            setTimeout(() => {
                input.focus();
            }, 500);
        }
    }

    closeSearchModal() {
        if (!this.searchModal) return;

        const backdrop = this.searchModal.querySelector(
            ".no-search-modal__backdrop"
        );
        const panel = this.searchModal.querySelector(".no-search-modal__panel");

        const app = App.getInstance();

        // 닫기 애니메이션
        const tl = gsap.timeline({
            onComplete: () => {
                this.searchModal.classList.remove("is-open");
                this.searchModal.setAttribute("aria-hidden", "true");

                if (!app.drawer.isDrawerOpen) {
                    app.setLock(false);
                }

                // 초기 상태로 리셋
                gsap.set(this.searchModal, {
                    opacity: 0,
                    visibility: "hidden",
                });
                gsap.set(panel, { y: -20, opacity: 0 });
                gsap.set(backdrop, { opacity: 0 });
            },
        });

        tl.to(panel, {
            y: -20,
            opacity: 0,
            duration: 0.3,
            ease: "power2.in",
        })
            .to(
                backdrop,
                {
                    opacity: 0,
                    duration: 0.3,
                    ease: "power2.in",
                },
                "-=0.2"
            )
            .to(
                this.searchModal,
                {
                    opacity: 0,
                    duration: 0.2,
                    ease: "power2.in",
                },
                "-=0.15"
            );
    }
}
